/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Digital_MusicInputs */

const en_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Music`)
};

const es_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Música`)
};

const fr_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musique`)
};

const de_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musik`)
};

const ja_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音楽`)
};

const zh_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音乐`)
};

const ar_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موسيقى`)
};

const id_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musik`)
};

const it_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musica`)
};

const ru_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Музыка`)
};

const pt_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Música`)
};

const ko_listing_category_digital_music = /** @type {(inputs: Listing_Category_Digital_MusicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`음악`)
};

/**
* | output |
* | --- |
* | "Music" |
*
* @param {Listing_Category_Digital_MusicInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_digital_music = /** @type {((inputs?: Listing_Category_Digital_MusicInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Digital_MusicInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_digital_music(inputs)
	if (locale === "es") return es_listing_category_digital_music(inputs)
	if (locale === "fr") return fr_listing_category_digital_music(inputs)
	if (locale === "de") return de_listing_category_digital_music(inputs)
	if (locale === "ja") return ja_listing_category_digital_music(inputs)
	if (locale === "zh") return zh_listing_category_digital_music(inputs)
	if (locale === "ar") return ar_listing_category_digital_music(inputs)
	if (locale === "id") return id_listing_category_digital_music(inputs)
	if (locale === "it") return it_listing_category_digital_music(inputs)
	if (locale === "ru") return ru_listing_category_digital_music(inputs)
	if (locale === "pt") return pt_listing_category_digital_music(inputs)
	return ko_listing_category_digital_music(inputs)
});